

if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce((e) => {
            console.log('[viewer slideChanged listener]', e);
            this.onSlideChanged(e);
          }, 500)
        );


        
        
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });

        const prevBtn = document.querySelector('.slider-button--prev');
        const nextBtn = document.querySelector('.slider-button--next');
        console.log(prevBtn+"++++++++++++++++++++123123++++++");
        if (prevBtn) { 
          console.log("here coming the test");
          // prevBtn.addEventListener('click', () => this.navigateThumbnail('prev'));
          prevBtn.addEventListener('click', () => {
            // Add your checks here
            console.log("prev clicked");
            this.navigateThumbnail('prev');
          });
        }
        if (nextBtn) {
          // nextBtn.addEventListener('click', () => this.navigateThumbnail('next'));
          nextBtn.addEventListener('click', () => {
            // Add your checks here
            console.log("next clicked");
            this.navigateThumbnail('next');
          });

        }

        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      navigateThumbnail(direction) {

        console.log(direction);
        console.log("")
        const thumbnails = Array.from(
          this.elements.thumbnails.querySelectorAll('.thumbnail-list__item.slider__slide')
        );
        if (!thumbnails.length) return;

        const currentIndex = thumbnails.findIndex((thumb) =>
          thumb.querySelector('button[aria-current="true"]')
        );

        if (currentIndex === -1) return;

        let newIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;
        if (newIndex < 0 || newIndex >= thumbnails.length) return;
        const newThumb = thumbnails[newIndex];
        const newBtn = newThumb.querySelector('button');
        const mediaId = newThumb.dataset.target;
        thumbnails.forEach((thumb) => {
          const btn = thumb.querySelector('button');
          if (btn) btn.removeAttribute('aria-current');
        });
        if (newBtn) newBtn.setAttribute('aria-current', 'true');
        this.setActiveMedia(mediaId, false);
      }

      onSlideChanged(event) {
        console.log('[onSlideChanged CALLED]', event);

        const current = event?.detail?.currentElement;
        console.log('[onSlideChanged currentElement]', current);

        const thumbnail = this.elements.thumbnails?.querySelector(
          `[data-target="${current?.dataset?.mediaId}"]`
        );

        console.log('[onSlideChanged thumbnail]', thumbnail);

        this.setActiveThumbnail(thumbnail);
      }


      setActiveMedia(mediaId, prepend) {

        console.log(mediaId);
        console.log(prepend);

        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

(function () {
  const MediaGallery = customElements.get('media-gallery');
  if (!MediaGallery) return;

  if (MediaGallery.prototype.__videoAutoplayPatched) return;
  MediaGallery.prototype.__videoAutoplayPatched = true;

  const originalPlayActiveMedia = MediaGallery.prototype.playActiveMedia;

  MediaGallery.prototype.playActiveMedia = function (activeItem) {
  console.log('[playActiveMedia CALLED]', activeItem);

  originalPlayActiveMedia.call(this, activeItem);

  const deferredMedia = activeItem.querySelector('.deferred-media');
  console.log('[deferredMedia]', deferredMedia);

  if (!deferredMedia) return;

  let attempts = 0;

  const waitForVideo = () => {
    const video = activeItem.querySelector('video');

    console.log(
      '[waitForVideo attempt]',
      attempts,
      'video:',
      video
    );

    if (!video) {
      if (++attempts < 20) {
        requestAnimationFrame(waitForVideo);
      }
      return;
    }

    console.log('[VIDEO FOUND]', video);

    // video.muted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    video.pause();

    try {
      video.currentTime = 0;
    } catch (e) {
      console.warn('[currentTime set error]', e);
    }

    const tryPlay = () => {
      console.log('[tryPlay] readyState:', video.readyState);

      if (video.readyState < 2) {
        requestAnimationFrame(tryPlay);
        return;
      }

      try {
        video.currentTime = 0.01;
      } catch (e) {}

      const p = video.play();
      console.log('[video.play CALLED]', p);

      if (p?.catch) {
        p.catch(err => {
          console.warn('[video.play BLOCKED]', err);
        });
      }
    };

    tryPlay();
  };

  waitForVideo();
};

})();


(function () {
  const MediaGallery = customElements.get('media-gallery');
  if (!MediaGallery) return;

  if (MediaGallery.prototype.__swipeAutoplayPatched) return;
  MediaGallery.prototype.__swipeAutoplayPatched = true;

  const originalOnSlideChanged = MediaGallery.prototype.onSlideChanged;

  MediaGallery.prototype.onSlideChanged = function (event) {
    // Shopify default behavior
    originalOnSlideChanged.call(this, event);

    // 🔑 WAIT for swipe to fully settle
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const slider = this.elements?.viewer?.slider;
        if (!slider) return;

        const activeItem = slider.currentElement;
        if (!activeItem) return;

        // Ensure correct active class
        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach(el => el.classList.remove('is-active'));

        activeItem.classList.add('is-active');

        // 🔥 Autoplay AFTER swipe settles
        this.playActiveMedia(activeItem);
      });
    });
  };
})();

document.addEventListener('slideChanged', function (event) {
  console.log(
    '[slideChanged EVENT]',
    {
      event,
      currentElement: event?.detail?.currentElement,
      mediaId: event?.detail?.currentElement?.dataset?.mediaId
    }
  );
});


(function () {
  function debounce(fn, delay) {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  document.querySelectorAll('media-gallery').forEach((gallery) => {
    const mediaList = gallery.querySelector('.product__media-list');
    if (!mediaList) return;

    let lastScrollLeft = 0;

    const onScrollEnd = debounce(() => {
      const items = Array.from(
        mediaList.querySelectorAll('.product__media-item')
      );

      if (!items.length) return;

      // Find most visible item
      let activeItem = null;
      let minDiff = Infinity;

      items.forEach((item) => {
        const diff = Math.abs(item.offsetLeft - mediaList.scrollLeft);
        if (diff < minDiff) {
          minDiff = diff;
          activeItem = item;
        }
      });

      if (!activeItem) return;

      console.log('[SCROLL END → ACTIVE ITEM]', activeItem);

      // Sync active class
      items.forEach(i => i.classList.remove('is-active'));
      activeItem.classList.add('is-active');

      // Trigger autoplay
      if (gallery.playActiveMedia) {
        gallery.playActiveMedia(activeItem);
      }
    }, 120);

    mediaList.addEventListener('scroll', () => {
      if (mediaList.scrollLeft !== lastScrollLeft) {
        lastScrollLeft = mediaList.scrollLeft;
        onScrollEnd();
      }
    });

    console.log('[MEDIA GALLERY SCROLL LISTENER ATTACHED]');
  });
})();




/**
 * Recover product gallery images that fail to load.
 * Retries only failed images and preserves normal responsive
 * image loading for images that load successfully.
 */
(() => {
  console.log('[Image Recovery] Script loaded');
  function recoverImage(img) {
    if (
      !img ||
      img.dataset.imageRecoveryAttempted === 'true'
    ) {
      return;
    }

    img.dataset.imageRecoveryAttempted = 'true';

    // Capture Safari's selected image URL before removing srcset.
    const imageUrl =
      img.currentSrc ||
      img.getAttribute('src');

    if (!imageUrl) return;

    img.removeAttribute('srcset');
    img.removeAttribute('sizes');

    // Force a fresh request using the selected image URL.
    img.src = imageUrl;
  }

  function monitorImage(img) {
    if (img.dataset.imageRecoveryMonitoring === 'true') {
      return;
    }

    img.dataset.imageRecoveryMonitoring = 'true';

    img.addEventListener('error', () => {
      recoverImage(img);
    });

    // Also handle images that failed before this script ran.
    if (img.complete && img.naturalWidth === 0) {
      recoverImage(img);
    }
  }

  function initializeGalleryImages() {
    document
      .querySelectorAll('.product__media img')
      .forEach(monitorImage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeGalleryImages,
      { once: true }
    );
  } else {
    initializeGalleryImages();
  }
})();
